<div class="footer flex">
  <div class="flex-auto flex items-center justify-center container">
    <div class="font-medium ltr:ml-4 rtl:mr-4 hidden sm:block">Landeshauptstadt Magdeburg | Zentrum für Telemann-Pflege und -Forschung</div>
  </div>
</div>
